// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--9aNz0";